// @ts-nocheck

import React, { Component } from 'react';
import Form from './Form';





export default class extends Component {
  render() {
    return <Form {...this.props} readonly={true} />;
  }
}
